export * from './IconVolumeUp';
